<div
  class="light-mode-overlay"
  [ngClass]="{ 'modifiers-bg': isOpenFromModifiers }"
>
  <prlw-icon name="eye-slash" class="light-mode-overlay__icon"></prlw-icon>
  <span class="light-mode-overlay__message">Доступно в PRO</span>
  <button class="light-mode-overlay__button" (click)="goToBuyLicense()">
    Стать PRO
  </button>
</div>
